import { SearchResultItem } from '../globalSearch.types';
import {
  GlobalSearchListItem,
  StaticCommand,
  StaticCommandType,
} from '../staticCommands/staticCommands.types';

interface UseGlobalSearchVisibleItemsParams {
  isAllTab: boolean;
  activeCommandType: StaticCommandType | null;
  allItems: SearchResultItem[];
  paginationItems: SearchResultItem[];
  commands: StaticCommand[];
}

const useGlobalSearchVisibleItems = ({
  isAllTab,
  activeCommandType,
  allItems,
  paginationItems,
  commands,
}: UseGlobalSearchVisibleItemsParams) => {
  const entityListItems: GlobalSearchListItem[] = (isAllTab ? allItems : paginationItems).map(
    (item) => ({ kind: 'entity', item }),
  );
  const commandListItems: GlobalSearchListItem[] = commands.map((command) => ({
    kind: 'command',
    command,
  }));

  const resolveVisibleItems = (): GlobalSearchListItem[] => {
    if (activeCommandType) {
      return commandListItems.filter(
        (listItem) => listItem.kind === 'command' && listItem.command.type === activeCommandType,
      );
    }
    return isAllTab ? [...entityListItems, ...commandListItems] : entityListItems;
  };

  const visibleItems: GlobalSearchListItem[] = resolveVisibleItems();

  return { visibleItems };
};

export default useGlobalSearchVisibleItems;
